import React from 'react';

const HomeContact = () => {
   return (
      <>
         <section className="contact__area">
            <div className="container-fluid p-0">
               <div className="row g-0">
                  <div className="col-xl-12">
                     <div className="contact__map">
                        <iframe title='contact' src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d4867.769717459098!2d-82.79871177373978!3d40.08956899356034!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x88385d897221cf03%3A0x25c8c0d9cd98b870!2s5051%20Forest%20Dr%20a%2C%20New%20Albany%2C%20OH%2043054%2C%20USA!5e0!3m2!1sen!2s!4v1723559243888!5m2!1sen!2s"></iframe>
                        <div className="contact__wrapper d-md-flex justify-content-between">
                           <div className="contact__info mr-100">
                              <h3>Get in touch</h3>
                              <ul>
                                 <li>
                                    <h4>Address</h4>
                                    <p>5051 FOREST DR STE A,<br /> NEW ALBANY, OH 43054</p>
                                 </li>
                                 <li>
                                    <h4>Call us</h4>
                                    <p><a href="tel:+16145340560">614-534-0560</a></p>
                                 </li>
                                 <li>
                                    <h4>Fax</h4>
                                    <p><a href="#">614-964-1543</a></p>
                                 </li>
                                 <li>
                                    <h4>Email Address</h4>
                                    <p><a href="mailto:dispatch@example.com">dispatch@jrdtrans.com</a></p>
                                 </li>
                              </ul>
                           </div>
                           <div className="contact__form">
                              <form action="#">
                                 <input type="text" placeholder="Your Name"/>
                                    <input type="email" placeholder="Your Email"/>
                                       <textarea placeholder="Your Message"></textarea>
                                       <button type="button" className="z-btn " >Send Message</button>
                                    </form>
                                 </div>
                           </div>
                        </div>
                     </div>
                  </div>
               </div>
         </section>
      </>
   );
};

export default HomeContact;